import AppDispatcher from '../dispatcher/AppDispatcher';
import TransactionsConstants from '../constants/TransactionsConstants';
import TransactionsParser from '../parsers/TransactionsParser';

class TransactionsActionCreator {
  /*
   ** Actions Triggered from views
   */
  getTransactions(id, sortOrder, sortField, typeFilter, startDate, endDate) {
    AppDispatcher.handleViewAction({
      actionType: TransactionsConstants.REQUEST_TRANSACTION_LIST_NEW,
      id,
      sortField,
      sortOrder,
      typeFilter,
      startDate,
      endDate,
    });
  }

  getTransactionsForMultipleAccounts(
    id,
    sortOrder,
    sortField,
    typeFilter,
    startDate,
    endDate,
    isPerAccount = false
  ) {
    AppDispatcher.handleViewAction({
      actionType: TransactionsConstants.REQUEST_TRANSACTIONS_ACCOUNT_POOL,
      id,
      sortField,
      sortOrder,
      typeFilter,
      startDate,
      endDate,
      isPerAccount,
    });
  }
  /*
   **Action to fetch tags for Tagging Component
   */
  getTags() {
    AppDispatcher.handleViewAction({
      actionType: TransactionsConstants.REQUEST_TAGS,
    });
  }

  /*
   ** Action to tag selected transactions
   */
  tagSelectedTransactions(transactions, tag, accountId) {
    AppDispatcher.handleViewAction({
      actionType: TransactionsConstants.REQUEST_TAG_SELECTED_TRANSACTIONS,
      transactions,
      tag,
      accountId,
    });
  }

  /*
   ** Actions to get search suggestions
   */
  getSearchTransactionSuggest(searchText) {
    AppDispatcher.handleViewAction({
      actionType: TransactionsConstants.REQUEST_SEARCH_SUGGESTION,
      searchText,
    });
  }

  /*
   ** Action to get the searched transactions
   */
  getTransactionSearchData(
    sortOrder,
    sortField,
    typeFilter,
    suggestData,
    startDate,
    endDate
  ) {
    AppDispatcher.handleViewAction({
      actionType: TransactionsConstants.REQUEST_SEARCH_TRANSACTIONS,
      sortField,
      sortOrder,
      typeFilter,
      suggestData,
      startDate,
      endDate,
    });
  }

  /*
   ** Action to add new tag
   */
  addNewTag(newTag) {
    AppDispatcher.handleViewAction({
      actionType: TransactionsConstants.REQUEST_ADD_NEW_TAG,
      newTag,
    });
  }

  /*
   ** Action to edit existing tag
   */
  editExistingTag(keyid, editTagValue) {
    AppDispatcher.handleViewAction({
      actionType: TransactionsConstants.REQUEST_EDIT_TAG,
      keyid,
      editTagValue,
    });
  }

  /**
   * Delete Existing Tag
   */
  deleteTag(deleteTagId) {
    AppDispatcher.handleViewAction({
      actionType: TransactionsConstants.REQUEST_DELETE_TAG,
      deleteTagId,
    });
  }

  /**
   * Sort SME Transactions
   */
  sortSMETransactions(sortColumn, sortDirection) {
    AppDispatcher.handleViewAction({
      actionType: TransactionsConstants.SORT_SME_TRANSACTIONS,
      sortColumn,
      sortDirection,
    });
  }
  /*
   ** Reset Search Data
   */
  resetSearch() {
    AppDispatcher.handleServerAction({
      actionType: TransactionsConstants.RESET_SEARCH,
    });
  }

  /*
   ** Reset suggest Pop Up
   */
  resetPopUp() {
    AppDispatcher.handleServerAction({
      actionType: TransactionsConstants.RESET_POPUP,
    });
  }

  /*
   ** Actions Triggered from servers
   */
  handleTransactionSuccess(response) {
    const transactions = TransactionsParser.parseTransactionsResponse(response);
    AppDispatcher.handleServerAction({
      actionType: TransactionsConstants.REQUEST_TRANSACTION_LIST_SUCCESS_NEW,
      data: transactions,
    });
  }

  handleEnrichedDataSuccess(response, transactionIdentifiers) {
    AppDispatcher.handleServerAction({
      actionType: TransactionsConstants.REQUEST_ENRICHED_DATA_SUCCESS,
      data: TransactionsParser.parseEnrichedDataResponse(
        response?.searchResults,
        transactionIdentifiers
      ),
    });
  }

  handleTagsListSuccess(response) {
    const tags = TransactionsParser.parseTagsResponse(response);
    AppDispatcher.handleServerAction({
      actionType: TransactionsConstants.REQUEST_TAGS_SUCCESS,
      data: tags,
    });
  }

  handleAssignTagSuccess() {
    AppDispatcher.handleServerAction({
      actionType:
        TransactionsConstants.REQUEST_TAG_SELECTED_TRANSACTIONS_SUCCESS,
    });
  }

  handleTransactionSearchSuggestionSuccess(response) {
    const suggestData = TransactionsParser.parseSuggestResponse(response);
    AppDispatcher.handleServerAction({
      actionType: TransactionsConstants.REQUEST_SEARCH_SUGGESTION_SUCCESS,
      suggestData,
    });
  }

  //---------------------------------------------------------------
  handleError() {
    AppDispatcher.handleServerAction({
      actionType: TransactionsConstants.SERVICE_ERROR,
    });
  }

  handleTagsServiceError(errorResponse) {
    AppDispatcher.handleServerAction({
      actionType: TransactionsConstants.TAGS_SERVICE_ERROR,
      tagsErrorMessage: errorResponse,
    });
  }

  handleTransactionServiceError(errorResponse, statusResponse) {
    AppDispatcher.handleServerAction({
      actionType: TransactionsConstants.TRANSACTION_SERVICE_ERROR,
      transactionsErrorMessage: errorResponse,
      statusResponse,
    });
  }

  handleEnrichedDataError(errorResponse) {
    AppDispatcher.handleServerAction({
      actionType: TransactionsConstants.ENRICHED_DATA_SERVICE_ERROR,
      errorMessage: errorResponse,
    });
  }

  handleAssignTagError(errorResponse) {
    AppDispatcher.handleServerAction({
      actionType: TransactionsConstants.REQUEST_TAG_SELECTED_TRANSACTIONS_ERROR,
      assignTagError: errorResponse,
    });
  }

  setApplyFilterStatus(applyFilterBtnStatus) {
    AppDispatcher.handleServerAction({
      actionType: TransactionsConstants.SET_APPLY_FILTER_STATUS,
      data: applyFilterBtnStatus,
    });
  }
}

export default new TransactionsActionCreator();
